export default {
    activateuser: {
        headerLabel: 'Onboarding van gebruikers',
        accountActivation: 'Rekening activering',
        step1: {
            header: 'Welkom op ons platform!',
            subHeader: 'Kies hoe u verbinding wilt maken met uw account',
            description:
                'Voor een eenvoudiger inlogproces raden we u aan uw account te verbinden met ten minste een van de volgende services.',
            OR: 'of',
            emailAndPassword: 'Gebruik je eigen e-mailadres',
        },
        step2: {
            header: 'Gebruik e-mail en wachtwoord',
            description:
                'dit is het belangrijkste e-mailadres dat aan uw account wordt gekoppeld. We raden je aan om een ​​ander e-mailadres te gebruiken dan je universiteitsadres om toegang te houden tot je gegevens na je afstuderen. U kunt eenvoudig bepalen welke e-mails u van ons ontvangt in uw accountinstellingen.',
            invalidEmail: 'het opgegeven e-mailadres is geen geldig e-mailadres.',
            passwordsNotMatch: 'De wachtwoorden moeten overeenkomen',
            passwordDescription01:
                'Om uw accountbeveiliging te garanderen, moet u een nieuw wachtwoord instellen. Maak een wachtwoord aan met het volgende:',
            passwordDescription02: 'Minimaal 8 tekens',
            passwordDescription03: 'Ten minste één kleine letter (a-z)',
            passwordDescription04: 'Ten minste één hoofdletter (A-Z)',
            passwordDescription05: 'ten minste één cijfer of speciaal symbool (0-9, !#$ enz.)',
            passwordDescription06: 'Minstens 6 unieke karakters',
            repeatPassword: 'herhaal wachtwoord',
        },
        step3: {
            header: 'Activerende gebruiker',
            loadingHints: {
                '0': 'Gebruikersgegevens laden',
                '1': 'Alles klaarmaken',
                '2': 'Nieuwe mogelijkheden om de hoek',
                '3': 'Bijna klaar!',
            },
            successHeader: 'Je account is nu klaar voor gebruik!',
            successSubheader: 'Je hebt nu toegang tot exclusieve functies!',
            errorHeader: 'kon account niet activeren',
            ifWrongContact:
                'Als je denkt dat dit niet klopt, neem dan contact op met de ondersteuning',
            contactForHelp: 'Neem contact op voor hulp',
            goBack: 'Ga terug',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Bekijk mijn voortgang',
            getStarted: 'Begin!',
            getToKnowYourself: 'Leer jezelf kennen',
            getToKnowYourselfBold: 'Maak kennis met <strong>jezelf</strong>',
            getToKnowYourFuture: 'Leer je toekomst kennen',
            getToKnowYourFutureBold: 'Maak kennis met uw <strong>toekomst</strong>',
            openAssessments: 'Beoordelingen openen',
            openAssessment: 'Beoordeling openen',
            unlock: 'ontgrendel de tests',
            testYourself: 'Test jezelf',
            takeTheFreeTests: 'Doe de gratis tests',
            youOwnThisProduct: 'Jij bezit dit product',
            startTest: 'Test starten',
            startTests: 'Testen starten',
            continue: 'Doorgaan met',
            showReport: 'Rapport weergeven',
            showYourReports: 'Toon uw rapporten',
            showYourReport: 'Toon uw rapport',
            continueFreeTests: 'Ga door met de gratis tests',
            continueTheTest: 'Ga verder met de test',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Test jezelf',
                description01: 'Welkom bij het Assessment Center - hier begint je loopbaantraject.',
                description02:
                    'hier kun je <strong>Aon Assessments</strong> doen, tests die door recruiters over de hele wereld worden gebruikt, die je geschiktheid en bereidheid voor een toekomstige carrière controleren.',
                freemium: {
                    description:
                        'Doe deze tests om uw sterke punten te meten en efficiënte rapporten van uw vaardigheden te krijgen.',
                    price: 'Vrij',
                    numTests: '3 testen',
                    timeEstimated: 'ca. 27 minuten',
                },
                premium: {
                    description:
                        'dit is de <strong>echte deal</strong>. Doe deze 3-in-1-test om erachter te komen welke carrièrepaden je moet volgen en ontvang een volledig kandidatenrapport.',
                    numTests: '3-in-1-test',
                    timeEstimated: 'ca. 60 minuten',
                    sampleReport: '↓Download voorbeeldrapport',
                    candidateReport: 'Kandidaat rapport',
                    candidateReportDescription:
                        'zodra u deze tests hebt voltooid, ontvangt u een volledig kandidatenrapport met een uitgebreid overzicht van uw resultaten, inclusief tips voor het verbeteren van uw persoonlijke vaardigheden, op welke vaardigheden u moet letten, de beste kansen om mee te beginnen, wat uw volgende stap moet zijn, en meer.',
                },
            },
            section2: {
                title: 'hoe zullen deze tests u helpen om aangenomen te worden?',
                t1: 'U kent uw <strong>vaardigheden</strong>',
                t2: 'Je realiseert je <strong>potentieel</strong>',
                t3: 'Je hebt een duidelijk <strong>carrièrepad</strong>',
                t4: 'Je vergroot je <strong>vertrouwen</strong>',
            },
            section3: {
                title:
                    'leer over uw persoonlijke sterke punten en carrièremogelijkheden om uw ontwikkeling en loopbaanontwikkeling te stimuleren.',
            },
            section4: {
                title: 'Wees uw concurrenten vandaag voor',
                description:
                    'door assessments in te vullen die wereldwijd door recruiters worden gebruikt bij bedrijven als Deloitte, Siemens, Burger King, Vodafone of P&G.',
            },
            section5: {
                title: 'Veel Gestelde Vragen',
                thisPage: 'deze pagina',
                question01: {
                    q: 'Wat zijn Aon-beoordelingen?',
                    a:
                        "Talent Assessments van Aon zijn wereldwijd erkende tests die bedrijven over de hele wereld helpen de beste kandidaten voor een baan te identificeren. met behulp van talentbeoordelingen kunnen recruiters verder kijken dan cv's, schoolcijfers, hogeschoolcertificaten en universitaire diploma's om erachter te komen of een kandidaat een goede match is.\n <br><br>\n Deze oplossingen zijn meestal gereserveerd <strong>voor alleen recruiters</strong> –hier krijg je een <strong>exclusieve</strong> kans om te oefenen en je resultaten te krijgen voorafgaand aan je sollicitatiegesprek. de meeste kandidaten krijgen deze kans niet, dus maak er gebruik van!",
                },
                question02: {
                    q: 'Moet ik betalen om deze beoordelingen te maken?',
                    a:
                        'U kunt 4 van deze tests gratis doen: <i>Werkgerelateerd gedrag</i>, <i>Numeriek redeneren</i>, <i>Deductief-logisch denken</i> en <i>Inductief- logisch redeneren</i>. deze tests meten uw vaardigheden en aanleg en zijn een geweldige manier om uw sterke en zwakke punten te achterhalen.\n\n <br><br>Als u echter een volledig overzicht wilt hebben van uw aanleg, kunt u professionele inzichten krijgen over jouw best passende carrièrepaden en zet een grote stapvoor uw toekomstige succes, kunt u ook toegang krijgen tot de 3-in-1-test en een uitgebreid kandidatenrapport krijgen voor € 79. <br><br>Voor de uitgebreide toegang, <a href={premiumLink}>klik hier</a> en betaal met een kaart – we gebruiken een veilige betaalmethode.\n',
                },
                question03: { q: 'waarom zou ik deze tests moeten doen?' },
                question04: {
                    q: 'Hoe kan ik me voorbereiden op deze tests?',
                    a:
                        'op <a href={link} target="_blank">deze pagina</a> kunt u alles lezen over technische vereisten en hoe u zich kunt voorbereiden op de beoordelingen. Daar vindt u ook materialen om u te helpen het te halen',
                },
                question05: {
                    q: 'Waar kan ik deze beoordelingen nog meer vinden?',
                    a:
                        'meestal wordt u door uw recruiter mogelijk gevraagd om deze tests uit te voeren - behalve dat, vindt u deze nergens anders voor u beschikbaar. Dit is een exclusieve kans voor jou om te oefenen, meer te weten te komen over jezelf en over je toekomstige carrière.',
                },
                question06: {
                    q: 'Hoe vaak kan ik de tests doen?',
                    a:
                        "je krijgt slechts één take voor elke test. Geen herkansingen! Zorg ervoor dat u comfortabele omstandigheden hebt om deze kans optimaal te benutten. U kunt vertrouwd raken met de test door instructievideo's te bekijken en een oefenoefening te doen voordat u de test doet.",
                },
                question07: {
                    q: 'in welke taal zijn deze tests?',
                    a:
                        '\n De standaardtaal voor deze tests is Engels, maar elk van hen heeft een verscheidenheid aan talen om uit te kiezen. U kunt controleren welke talen beschikbaar zijn en de taal kiezen die het beste bij u past voordat u de test doet. \\N',
                },
                question08: {
                    q: 'is er een vervaldatum op de uitgebreide tests zodra ik ervoor betaal?',
                    a:
                        'Nee! Nadat uw betaling is geaccepteerd, kunt u de uitgebreide tests doen wanneer u maar wilt. Neem de tijd om de beoordelingen voor te bereiden en te starten op het moment dat u het beste uitkomt.',
                },
            },
        },
        center: {
            banner: {
                title: 'Controleer je voortgang',
                subtitle: 'hier is een overzicht van je voortgang in loopbaanbeoordelingen',
                moreInfo: 'Meer informatie',
                yourProgress: 'Jouw vooruitgang',
                quote:
                    'Het stellen van doelen is de eerste stap om het onzichtbare in het zichtbare te veranderen.',
            },
            list: {
                timeEstimated: 'ca. {minuten} min',
                freemium: {
                    intro:
                        '\n Dit is de eerste stap in je persoonlijke ontwikkelingsreis! <br />\n Doe deze tests om uw sterke punten te meten en efficiënte rapporten te krijgen van uw\n vaardigheden.\n',
                },
                premium: {
                    intro:
                        '\n Dit is het echte werk.<br />\n Doe deze tests om erachter te komen welke carrièrepaden je moet volgen en\n ontvang een uitgebreid <strong>kandidaatrapport</strong>.\n',
                    description:
                        '\n Uw <strong>Kandidaatrapport</strong> geeft u een uitgebreid\n overzicht van uw resultaten, inclusief <strong>tips</strong> over het verbeteren van uw\n persoonlijke vaardigheden, die <strong>vaardigheden</strong> zijn waar u op moet letten, de\n beste <strong>mogelijkheden</strong> om mee te beginnen, wat uw\n <strong>volgende stap</strong> zou moeten zijn, en meer.\n ',
                },
            },
            instruments: {
                '344': {
                    name: 'Deductief-logisch denken',
                    description:
                        'Kijk hoe goed je bent in het toepassen van kennis en het toepassen van regels – deze test meet je analytisch en probleemoplossend vermogen.',
                    estimatedTime: '9',
                },
                '383': {
                    name: 'Inductief-logisch redeneren',
                    description:
                        'Hoe goed herken jij regels en onderlinge verbanden? controleer met deze test die uw analytisch en probleemoplossend vermogen meet.',
                    estimatedTime: '9',
                },
                '390': {
                    name: 'Werkgerelateerd gedrag',
                    description:
                        'Welke persoonlijkheidskenmerken van medewerkers heb je? Kom erachter door deze test te doen die uw persoonlijkheidskenmerken op het werk identificeert.',
                    estimatedTime: '30',
                },
                '721': {
                    name: 'Numeriek redeneren',
                    description:
                        'hoe goed ben jij met het kraken van cijfers? Deze test meet uw begrip van numerieke informatie en het trekken van logische conclusies.',
                    estimatedTime: '9',
                },
                '5392': {
                    name: 'Werkgeheugen',
                    description:
                        'Hoe goed kun jij gefocust blijven? Deze test meet het vermogen om informatie te verwerken en te onthouden in afleidende omgevingen.',
                    estimatedTime: '15',
                },
                '82013': {
                    name: 'flexTest',
                    description:
                        'wat zijn uw interesses? Deze vragenlijst zal helpen bepalen welke carrièrepaden je zou willen volgen.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Start je Aon-assessments',
            consent:
                'ik begrijp dat Aon verantwoordelijk is voor mijn gegevens met betrekking tot deze beoordeling en ga akkoord met hun algemene voorwaarden.\n Ik ga er ook mee akkoord dat Highered mijn naam kan overdragen aan Aon om mijn rapport te genereren.',
            startTest: 'Test starten',
            consentErrorTitle: 'Toestemmingsfout',
            consentErrorMessage:
                'Er is iets misgegaan bij het indienen van uw toestemming. heb je je e-mail bevestigd?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats": {
        '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair': {
            " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire": {
                '"':
                    '전 세계의 \n 채용 담당자들은 후보 선발 과정에서 AON 평가 테스트를 사용합니다. 미리 이 테스트를 받아 준비된 보고서를 제출함으로서 당신은 채용 담당자들을 깜짝 놀라게 할 좋은 기회를 얻게됩니다. 어떻게냐고요? \n <br><br>\n 첫째, 채용 과정의 일부를 미리 준비해 두면 다른 지원자들보다 한 발 앞서 나갈 수 있습니다.\n <br><br><\n 둘째 – 명확한 생각을 갖고 채용에 접근하게 됩니다. 당신은 자신의 강점이 무엇이고 자신의 미래가 어떨지 알게 됩니다. 즉, 즉각적인 동기 부여와 적절한 자신감이 갖춰지게 된다는 뜻이죠! 채용 담당자들도 한 눈에 그걸 알아차릴 수 있을 겁니다.',
            },
        },
    },
    calendar: {
        header: 'Kalender',
        myCalendar: 'Mijn kalender',
        noCalendar: 'Your Career Services heeft de kalenderfunctie nog niet geactiveerd.',
        goBackBtn: 'Ga terug',
        calendarNotReady: 'De functionaliteit "mijn agenda" is nog niet klaar. Komt binnenkort',
        noUpcomingAppointments: 'U heeft geen aanstaande afspraken.',
        appointmentMissing: 'Afspraak niet actief',
        appointmentNotActive:
            'sorry, u heeft geprobeerd een afspraak te bekijken die niet bestaat of niet actief is.',
        appointmentNotHavingAvailability:
            'Sorry, deze afspraak is momenteel niet beschikbaar. Kom later terug.',
        appointmentMissingRules: 'Afspraak heeft geen beschikbaarheid',
        needToCompleteProfile: 'Voltooi uw profiel',
        noUpcomingAppointmentsPleaseBook: 'Maak een afspraak om uw agenda te ontgrendelen.',
        bookAppointment: 'Afspraak maken',
        bookAnotherAppointment: 'Een afspraak maken',
        attendedAppointments: 'afspraken die je hebt bijgewoond',
        aboutAppointments: {
            header: 'Over afspraken',
            button: 'Over',
            block1: {
                header: 'Wat is een afspraak?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. exceptioneur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. exceptioneur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
            block2: {
                header: 'Met wie kan ik contact opnemen voor meer informatie?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. exceptioneur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. exceptioneur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        },
        bookAnAppointment: 'Een afspraak maken',
        backToCalendarBtn: 'Terug naar kalender',
        backToBookingBtn: 'Terug naar afsprakenlijst',
        firstAvailable: 'Eerst beschikbaar',
        loadingAppointment: 'Bezig met laden ...',
        bookModal: {
            title: 'Bevestig boeking',
            with: 'Met',
            confirm: 'Bevestigen',
            continue: 'Doorgaan met',
            cancel: 'Dichtbij',
            first: {
                title: 'Dit is je eerste afspraak',
                description:
                    'om ervoor te zorgen dat u de uitnodiging voor het evenement ontvangt, moet u bevestigen dat u toegang heeft tot een persoonlijke agenda via dit e-mailaccount',
                ok: 'OK',
                wrongEmail: 'Foute email?',
            },
            changeEmail: {
                title: 'Selecteer je agenda e-mail',
                inputPlaceholder: 'Typ e-mail ...',
                ok: 'OK',
                back: 'Gebruik standaard',
            },
            unknownErrorHeader: 'Er is een fout opgetreden bij het boeken',
            unknownErrorBody:
                'probeer een andere keer te boeken, en als dit niet werkt, neem dan contact op met de ondersteuning.',
            confirmationHeader: 'Je afspraak is geboekt!',
            bookedTheFollowing: 'Details:',
            emailWillBeSent: 'Er wordt een e-mail gestuurd naar',
            withConfirmation: 'om uw aanwezigheid te bevestigen.',
        },
        dateDetailsModal: { title: 'Afspraken op' },
        completedYourProfile:
            'Je moet je profiel voltooien om toegang te krijgen tot het kalendersysteem',
        toMyProfile: 'Mijn profiel bewerken',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} wil je profiel zien',
            content: 'Wil je je profiel met deze persoon delen?',
            share: 'Profiel delen',
            reject: 'Nee',
        },
    },
    companyDetail: {
        locations: {
            header: 'Locaties',
            viewAll: 'Alles zien',
            noLocations: 'Geen locaties',
            allLocations: 'Alle locaties',
        },
        jobModule: {
            header: 'Topposities',
            viewAllJobs: 'Bekijk alle vacatures van {companyName}',
            noPositions: '{companyName} heeft momenteel geen openstaande vacatures bij Highered.',
            defaultLabel: 'Open posities',
        },
        videos: {
            header: 'Videos',
            noVideos: "Geen video's",
            noMoreVideos: "geen video's meer",
            moreVideosFrom: "Meer video's van {companyName}",
        },
        articles: {
            header: 'Lidwoord',
            noArticles: 'Geen artikelen',
            noMoreArticles: 'Geen artikelen meer',
            moreArticlesFrom: 'Meer artikelen van {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Creëren' },
            yearMonthPicker: { defaultSelect: 'Selecteer een maand' },
            localeDropdown: {
                languages: { en: 'Engels', cn: 'Chinese', fr: 'Frans' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Verifieer je school-e-mailadres',
                description:
                    'het is een snel proces en geeft je toegang tot\n exclusieve functies zoals unieke vacatures, vaardigheidstests\n en loopbaanbronnen.',
                verificationPending: 'Verificatie in behandeling',
                weHaveSentAnEmail:
                    'We hebben een e-mail gestuurd naar\n <strong>{studentEmail}</strong> voor\n om jezelf te verifiëren. zorg ervoor dat\n controleer uw spammap, aangezien veel scholen\n behoorlijk streng zijn op inkomende e-mails.',
                verifyMe: 'Verifieer mij',
                resendVerifyEmail: 'Verificatie-e-mail opnieuw verzenden',
                cancelVerification: 'Verificatie annuleren',
                emailSent: 'Email verzonden',
                emailSentMessage:
                    'E-mail is succesvol verzonden. als je het niet ontvangt, neem dan contact met ons op via support@highered.global.',
                resendErrorTitle: 'Fout tijdens het opnieuw verzenden van e-mail',
                resendErrorMessage:
                    'Kon de verificatie-e-mail niet opnieuw verzenden. Neem contact met ons op via support@highered.global.',
                verificationCancelledTitle: 'Verificatie geannuleerd',
                verificationCancelledMessage: 'Verificatie is succesvol geannuleerd.',
                cancelErrorTitle: 'Fout tijdens annuleren',
                cancelErrorMessage:
                    'kon de verificatie niet annuleren. Neem contact met ons op via support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Verifieer je school-e-mailadres',
                university: 'Academische instelling',
                studentEmail: 'Je academische e-mailadres',
                studentEmailPlaceholder: 'Academische e-mail',
                message: 'Bericht',
                verify: 'Verifiëren',
                sendRequest: 'Verzend verzoek',
                verificationInProcess: 'Verificatie bezig',
                emailHasBeenSentTo:
                    'Er is een e-mail verzonden naar <strong>{email}</strong>. volg de instructies daar om uw verbinding met <strong>{schoolName}</strong> . te verifiëren',
                verificationRequestSentNonAcademic:
                    'Carrièreservices bij <strong>{schoolName}</strong> moeten je verbinding verifiëren. U wordt per e-mail op de hoogte gebracht wanneer dat gebeurt.',
                ifNoEmailRecieved:
                    'Neem contact met ons op als u de verificatiemail niet heeft ontvangen.',
                contactHelp: 'neem contact met ons op voor hulp',
                doNotHaveAcademicEmail: 'Ik heb geen academisch e-mailadres',
                doubleCheckEmail:
                    'Controleer nogmaals of dit e-mailadres correct is en of u er toegang toe heeft.',
                haveAcademicEmail: 'Ik heb een academisch e-mailadres',
                noAcademicEmailInfo:
                    'Als u geen academisch e-mailadres gebruikt, moet uw verzoek handmatig worden goedgekeurd door Career Services. u moet daarom een ​​kort bericht aanleveren om u te identificeren.',
                alreadyVerifiedInfo: 'Je bent al geverifieerd op deze school.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Mijn pagina',
                jobs: 'Banen',
                companies: 'bedrijven',
                resources: 'Masterclasses',
                assessments: 'Beoordelingen',
                countryGuides: 'Landengidsen',
                goToHaigui: 'Banen in China',
                signIn: 'Log in Schrijf in',
                vfairs: 'Virtuele evenementen',
                events: 'Evenementen',
                newFeature: 'Nieuwe functie!',
            },
            profileNavigation: { signOut: 'Afmelden' },
            sidebar: {
                myPage: 'Mijn pagina',
                myProfile: 'Mijn profiel',
                findJobs: 'Vind banen',
                findCompanies: 'Vind bedrijven',
                resources: 'masterclasses',
                assessments: 'Beoordelingen',
                countryGuides: 'Landengidsen',
                goToHaigui: 'Banen in China',
                virtualFairs: 'Virtuele evenementen',
                signIn: 'Log in Schrijf in',
                logOut: 'Uitloggen',
            },
            backToCalendar: 'Terug naar kalender',
            allBooths: 'Alle stands',
            home: 'Thuis',
        },
        smart: {
            companyModule: {
                followJob: 'Toevoegen aan favorieten',
                followCompany: 'Volg bedrijf',
                unFollowJob: 'Verwijder van favorieten',
                unFollowCompany: 'Bedrijf niet meer volgen',
                favoritedTitle: 'Opgeslagen in favorieten',
                favoritedMessage:
                    'Deze positie is opgeslagen in je favorieten. vind je favoriete posities op mijn pagina.',
                unfavoritedTitle: 'Verwijderd uit favorieten',
                unfavoritedMessage: 'Deze positie is verwijderd uit je favorieten.',
                favoriteErrorTitle: 'Er is iets fout gegaan',
                favoriteErrorMessage: 'Kon deze positie niet favoriet maken',
                showAllCompanies: 'Toon alle bedrijven',
                showOnlyCompaniesLiveOnChat: 'Toon alleen bedrijven live op chat',
            },
            profileModule: {
                profileCompletion: 'Profielaanvulling',
                profileCompletionEncouragement:
                    'laat jezelf zien aan werkgevers door de laatste {percentageLeft} van je profiel in te vullen',
                gotoProfilePage: 'Profiel bijwerken',
                profileCompleted: 'Profiel voltooid',
                profileCompletedWhatsNext:
                    'Wist je dat de meeste werkgevers online assessments gebruiken in hun wervingsprocessen? Oefen nu en krijg inzicht in uw sterke en zwakke punten.',
                gotoTestsPage: 'Ga naar beoordelingscentrum',
                authIndication: {
                    title: 'vind je droombaan',
                    description:
                        'Wilt u toegang tot functies die uniek zijn voor uw school, en tests die uw zoektocht naar een baan een boost zullen geven? Maak vandaag nog eenvoudig een gebruiker aan met Google, LinkedIn of Facebook.',
                    action: 'Laten we gaan',
                },
                toProfileHint: 'Naar mijn profiel',
                toProfileUncompletedHint:
                    'Je profiel is niet 100% compleet. ga verder met invullen om uw inzetbaarheid te maximaliseren.',
                profileActions: {
                    addFirstName: 'Voornaam toevoegen',
                    addLastName: 'Achternaam toevoegen',
                    addNationality: 'Nationaliteit toevoegen',
                    addPhoneNumber: 'Voeg je telefoonnummer toe',
                    addLanguage: 'Een taal toevoegen',
                    addEducation: 'Een opleiding toevoegen',
                    addEmail: 'Voeg je e-mailadres toe',
                    addGender: 'Voeg je geslacht toe',
                },
            },
            featuredCompanies: { label: 'Aanbevolen bedrijven' },
            featuredPositions: { label: 'Aanbevolen posities' },
            featuredResource: {
                header: 'Doe mee aan de virtuele conferentie',
                cta: 'Kijk nu!',
                wechatSignupHeader: 'volg het Highered WeChat-account om updates te krijgen',
                wechatSignupCta: 'Scan code naar nu!',
            },
        },
    },
    '"': 'Scanați codul acum!',
    cts: {
        filterNames: {
            employment_types: 'Soorten werkgelegenheid',
            education_level: 'Graden',
            job_category: 'Velden',
            address: 'Locaties',
            sector: 'Sectoren',
            exclude_school_id: 'Uitsluiten',
            languages: 'Talen',
        },
        excludeSchoolIds: {
            '-1': 'Gedeelde berichten',
            unknownSchoolId: 'EFMD-schoolpartner',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Bachelors',
            MASTERS_OR_EQUIVALENT: 'Masters',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Full time',
            INTERN: 'Stage',
            TEMPORARY: 'Deeltijd',
            PART_TIME: 'Deeltijd',
        },
        startDate: 'Begin',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Boekhouding en financiën',
            ADMINISTRATIVE_AND_OFFICE: 'Administratief en kantoor',
            ADVERTISING_AND_MARKETING: 'Adverteren en marketing',
            ART_FASHION_AND_DESIGN: 'Kunst mode en design',
            BUSINESS_OPERATIONS: 'Zakelijke operaties',
            COMPUTER_AND_IT: 'Computer en IT',
            CUSTOMER_SERVICE: 'Klantenservice',
            EDUCATION: 'Onderwijs',
            HEALTHCARE: 'Gezondheidszorg',
            HUMAN_RESOURCES: 'Personeelszaken',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'installatie onderhoud en reparatie',
            LEGAL: 'legaal',
            MANAGEMENT: 'Beheer',
            MANUFACTURING_AND_WAREHOUSE: 'Productie en magazijn',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Mediacommunicatie en schrijven',
            OIL_GAS_AND_MINING: 'Energie',
            PROTECTIVE_SERVICES: 'Beschermende diensten',
            REAL_ESTATE: 'Onroerend goed',
            SALES_AND_RETAIL: 'Verkoop en detailhandel',
            SCIENCE_AND_ENGINEERING: 'Wetenschap en techniek',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Sociale diensten en non-profit',
            TRANSPORTATION_AND_LOGISTICS: 'Transport en logistiek',
        },
        sectors: {
            Consulting: 'Overleg plegen',
            'Consumer Goods': 'Consumentengoederen',
            'Financial Services / Banking': 'financiële diensten / bankieren',
            'Goverment / Public Administration / Non Profit':
                'Overheid / Openbaar Bestuur / Non-profit',
            'International Trade & Development': 'Internationale handel en ontwikkeling',
            Manufacturing: 'productie',
            'Media / Entertainment': 'Media / Amusement',
            'Petroleum / Energy': 'Aardolie / Energie',
            'Pharma / Healthcare / Biotech': 'Farma / Gezondheidszorg / Biotechnologie',
            'Real Estate / Construction / Infrastructure': 'Vastgoed / Bouw / Infra',
            'Technology (IT) / Telecom': 'Technologie (IT) / Telecom',
            'Transportations & Logistics': 'Transport en logistiek',
            Other: 'Ander',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hongkong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa & Sub-Sahara Afrika',
            'Hong Kong': 'Hongkong',
            'Korea, South': 'Zuid-Korea',
            'New Zealand': 'Nieuw-Zeeland',
            'Papua-Ny Guinea': 'Papoea-Nieuw-Guinea',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Saoedi-Arabië',
            'South Africa': 'Zuid-Afrika',
            'South Korea': 'Zuid-Korea',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwan',
            'The Seychell Islands': 'Seychellen',
            'United Arab Emirates': 'Verenigde Arabische Emiraten',
            'United Kingdom': 'Verenigd Koningkrijk',
            'Ivory Coast': 'Ivoorkust',
            Afghanistan: 'Afghanistan',
            Algeria: 'Algerije',
            Angola: 'Angola',
            Argentina: 'Argentinië',
            Armenia: 'Armenië',
            Australia: 'Australië',
            Austria: 'Oostenrijk',
            Azerbaijan: 'Azerbeidzjan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrein',
            Bangladesh: 'Bangladesh',
            Belarus: 'Wit-Rusland',
            Belgium: 'België',
            Botswana: 'Botswana',
            Brazil: 'Brazilië',
            Bulgaria: 'Bulgarije',
            Cambodia: 'Cambodja',
            Canada: 'Canada',
            Chile: 'Chili',
            China: 'China',
            Colombia: 'Colombia',
            Congo: 'Congo',
            Croatia: 'Kroatië',
            Cyprus: 'Cyprus',
            Czechia: 'Tsjechië',
            Denmark: 'Denemarken',
            Ecuador: 'Ecuador',
            Egypt: 'Egypte',
            Estonia: 'Estland',
            Ethiopia: 'Ethiopië',
            Fiji: 'Fiji',
            Finland: 'Finland',
            France: 'Frankrijk',
            Germany: 'Duitsland',
            Ghana: 'Ghana',
            Greece: 'Griekenland',
            Guernsey: 'Guernsey',
            Hungary: 'Hongarije',
            Iceland: 'IJsland',
            India: 'India',
            Indonesia: 'Indonesië',
            Iraq: 'Irak',
            Ireland: 'Ierland',
            Israel: 'Israël',
            Italy: 'Italië',
            Japan: 'Japan',
            Jersey: 'Jersey',
            Jordan: 'Jordanië',
            Kazakhstan: 'Kazachstan',
            Kenya: 'Kenia',
            Kuwait: 'Koeweit',
            Laos: 'Laos',
            Latvia: 'Letland',
            Lebanon: 'Libanon',
            Lithuania: 'Litouwen',
            Luxembourg: 'Luxemburg',
            Malaysia: 'Maleisië',
            Malta: 'Malta',
            Mauritania: 'Mauritanië',
            Mauritius: 'Mauritius',
            Mexico: 'Mexico',
            Mongolia: 'Mongolië',
            Morocco: 'Marokko',
            Myanmar: 'Myanmar',
            Namibia: 'Namibië',
            Netherlands: 'Nederland',
            Nigeria: 'Nigeria',
            Norway: 'Noorwegen',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Filippijnen',
            Poland: 'Polen',
            Portugal: 'Portugal',
            Qatar: 'Qatar',
            Romania: 'Roemenië',
            Russia: 'Rusland',
            Senegal: 'Senegal',
            Serbia: 'Servië',
            Singapore: 'Singapore',
            Slovakia: 'Slowakije',
            Slovenia: 'Slovenië',
            Spain: 'Spanje',
            Sudan: 'Soedan',
            Swaziland: 'Swaziland',
            Sweden: 'Zweden',
            Switzerland: 'Zwitserland',
            Syria: 'Syrië',
            Taiwan: 'Taiwan',
            Tanzania: 'Tanzania',
            Thailand: 'Thailand',
            Tonga: 'Tonga',
            Turkey: 'kalkoen',
            Ukraina: 'Oekraïne',
            Ukraine: 'Oekraïne',
            USA: 'VS',
            Uzbekistan: 'Oezbekistan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Zambia',
        },
        languages: {
            Aceh: 'Atjeh',
            Afrikaans: 'Afrikaans',
            Albanian: 'Albanees',
            Amharic: 'Amhaars',
            Arabic: 'Arabisch',
            Arakanese: 'Arakanezen',
            Armenian: 'Armeens',
            Azeri: 'Azeri',
            Badini: 'Badini',
            Basque: 'baskisch',
            Belarusian: 'Wit-Russisch',
            Bengali: 'Bengaals',
            Berber: 'Berber',
            Bosnian: 'Bosnisch',
            Bulgarian: 'Bulgaars',
            Burmese: 'Birmees',
            Cantonese: 'Kantonees',
            Catalan: 'Catalaans',
            Cebuano: 'cebuano',
            Chechen: 'Tsjetsjeens',
            Chin: 'Kin',
            Chinese: 'Chinese',
            Croatian: 'Kroatisch',
            Czech: 'Tsjechisch',
            Danish: 'Deens',
            Dari: 'Dari',
            Dutch: 'Nederlands',
            English: 'Engels',
            Estonian: 'Ests',
            Faroese: 'Faeröers',
            Filipino: 'Filipijns',
            Finnish: 'Fins',
            French: 'Frans',
            German: 'Duitse',
            Greek: 'Grieks',
            Greenlandic: 'Groenlands',
            Hausa: 'Hausa',
            Hebrew: 'Hebreeuws',
            Hindi: 'Hindi',
            Hungarian: 'Hongaars',
            Icelandic: 'IJslands',
            Indonesian: 'Indonesisch',
            Italian: 'Italiaans',
            Japanese: 'Japans',
            Kazakh: 'Kazachs',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Koreaans',
            Kurdish: 'Koerdisch',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latijns',
            Latvian: 'Lets',
            Lingala: 'Lingala',
            Lithuanian: 'Litouws',
            Macedonian: 'Macedonisch',
            Malagasy: 'Madagaskar-',
            Malaysian: 'Maleisisch',
            Mandarin: 'Mandarijn',
            Mongolian: 'Mongools',
            Nepali: 'Nepalees',
            Norwegian: 'Noors',
            Oromo: 'Oromo',
            Other: 'Ander',
            Panjabi: 'Panjabi',
            Pashto: 'Pasjtoe',
            Persian: 'Perzisch',
            Polish: 'Pools',
            Portuguese: 'Portugees',
            Punjabi: 'Punjabi',
            Romanes: 'Romanes',
            Romani: 'Romani',
            Romanian: 'Roemeense',
            Russian: 'Russisch',
            Sami: 'Sami',
            Serbian: 'Servisch',
            Sign_language: 'Gebarentaal',
            Slovak: 'Slowaaks',
            Slovene: 'Sloveens',
            Somali: 'Somalisch',
            Sorani: 'Sorani',
            Spanish: 'Spaans',
            Swahili: 'Swahili',
            Swedish: 'Zweeds',
            Tagalog: 'Tagalog',
            Tamil: 'Tamil',
            Thai: 'Thais',
            Tigrinya: 'Tigrinya',
            Turkish: 'Turks',
            Ukrainian: 'Oekraïens',
            Urdu: 'Urdu',
            Uyghur: 'Oeigoerse',
            Vietnamese: 'Vietnamees',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Email verificatie',
        verifyingEmail: 'E-mail verifiëren',
        emailVerifySuccess: 'Je e-mailadres is geverifieerd!',
        emailVerifyFailure:
            'Er is iets misgegaan... probeer het later opnieuw of neem contact op met de ondersteuning',
        gotoMyPage: 'Ga terug naar Mijn pagina',
    },
    errors: {
        defaultErrorMessage: 'Er is een fout opgetreden!',
        logInErrorText: {
            invalidCredentials: 'verkeerde gebruikersnaam of wachtwoord',
            inactiveUser:
                'De gebruiker met het opgegeven e-mailadres is inactief. controleer uw e-mail voor account-activering of probeer uw wachtwoord opnieuw in te stellen.',
            default: 'Kon niet verifiëren.',
        },
        registerErrorText: {
            passwordTooShort: 'Wachtwoord moet minimaal 8 cijfers lang zijn.',
            emailAlreadyInUse: 'Het opgegeven e-mailadres is al in gebruik.',
            emailTaken:
                'Email is al in gebruik. als je je school-e-mailadres hebt gebruikt, kan dit gebeuren omdat je een gebruiker had voordat het platform werd geüpgraded (op highedtalent.org).',
            default: 'Het is niet gelukt om een ​​gebruiker aan te maken.',
        },
        invalidTokenText: { default: 'Uw token is ongeldig of is verlopen.' },
        passwordErrorText: {
            passwordTooShort: 'Wachtwoord moet minimaal 8 cijfers lang zijn.',
            requireNonAlphanumeric: 'Het wachtwoord moet minimaal één speciaal teken bevatten.',
            requireLowerCase: 'het wachtwoord moet minimaal één kleine letter bevatten.',
            requireUpperCase: 'Het wachtwoord moet minimaal één hoofdletter bevatten.',
            requireUniqueChars: 'Het wachtwoord moet minimaal 6 verschillende karakters bevatten',
            default: 'Kon wachtwoord niet wijzigen',
        },
        recoverErrorText: {
            userNotFound: 'De gebruiker bestaat niet! Neem contact op met ondersteuning.',
            userAlreadyActive: 'De gebruiker is al geactiveerd!\nProbeer in te loggen.',
            emailAlreadyInUse:
                'Het opgegeven e-mailadres is al in gebruik.\nAls je verder wilt gaan met de accountactivering, probeer dan een ander e-mailadres of een andere sociale login. Ga anders naar de startpagina en log in op uw account.',
            default: 'Kan account niet activeren.\nProbeer het later opnieuw.',
        },
        socialAuthErrorText: {
            errorTitle: 'kon niet inloggen met {provider}',
            invalidProviderGoogle:
                'De gebruiker met het opgegeven e-mailadres is niet verbonden met Google. Probeer bijvoorbeeld in te loggen met LinkedIn, Facebook of e-mail.',
            invalidProviderFacebook:
                'De gebruiker met het opgegeven e-mailadres is niet verbonden met Facebook. Probeer bijvoorbeeld in te loggen met Google, LinkedIn of e-mail.',
            invalidProviderLinkedIn:
                'de gebruiker met het opgegeven e-mailadres is niet verbonden met LinkedIn. Probeer bijvoorbeeld in te loggen met Google, Facebook of e-mail.',
            invalidProviderWeChat:
                'De gebruiker met het opgegeven e-mailadres is niet verbonden met WeChat. Probeer bijvoorbeeld in te loggen met Google, Facebook of e-mail.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'het door u opgegeven e-mailadres is al in gebruik. Dit kan zijn omdat u een gebruiker had voordat het platform werd geüpgraded (op highedtalent.org). Neem contact op met ondersteuning.',
            invalidEmailDomain:
                'Het opgegeven e-maildomein komt niet overeen met de opgegeven universiteit. Kies de juiste universiteit.',
            existingConnection: 'de gebruiker is al verbonden met de opgegeven universiteit',
            default: 'Kon de verificatie niet starten.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'Email is al in gebruik',
                default: 'Kon niet updaten',
            },
        },
    },
    favorites: {
        header: 'Mijn favorieten',
        active: 'Actief',
        expired: 'Verlopen',
        expiresThisMonth: 'Deadline voor aanmelding deze maand',
        expiresThisWeek: 'Deadline voor aanmelding deze week',
        expiresLater: 'Deadline voor aanmelding later',
        noActiveFavorites: 'Je hebt geen actieve favoriete posities',
        noExpired: 'je hebt geen verlopen favoriete posities',
    },
    findcompanies: {
        headerLabel: 'Vind bedrijven',
        companyListLabel: 'bedrijven',
    },
    findjobs: {
        header: 'Vind banen',
        changeFilters: 'Filters wijzigen',
        recruitmentModule: {
            body:
                'Ben jij een recruitment officer, carrièreprofessional of gewoon\n geïnteresseerd in het aannemen van studenttalent?',
            createJob: 'Klik hier om een ​​vacature aan te maken',
        },
    },
    general: {
        documentTitle: 'Wereldwijd kansenplatform',
        email: 'E-mail',
        password: 'Wachtwoord',
        confirmPassword: 'Bevestig wachtwoord',
        loading: 'Bezig met laden',
        ok: 'OK',
        save: 'Sparen',
        add: 'toevoegen',
        close: 'Dichtbij',
        delete: 'Verwijderen',
        cancel: 'Annuleren',
        done: 'Klaar',
        continue: 'Doorgaan met',
        back: 'Rug',
        next: 'Volgende',
        finish: 'Af hebben',
        success: 'Succes',
        error: 'Fout',
        description: 'Beschrijving',
        months: {
            '0': 'Jan',
            '1': 'februari',
            '2': 'maart',
            '3': 'april',
            '4': 'Kunnen',
            '5': 'juni',
            '6': 'juli',
            '7': 'augustus',
            '8': 'september',
            '9': 'okt',
            '10': 'november',
            '11': 'december',
        },
        days: {
            '0': 'zon',
            '1': 'maandag',
            '2': 'di',
            '3': 'wo',
            '4': 'donderdag',
            '5': 'vrij',
            '6': 'Za',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Uw in behandeling zijnde verificatie controleren',
                verifySchoolConnection:
                    'Verifieer je schoolverbinding om toegang te krijgen tot deze bronnen',
                logInToAccessMoreFeatures: 'Duizenden internationale carrièremogelijkheden',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Aangedreven door',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: "Dit bedrijf is een 'Great Place To Work' gecertificeerd bedrijf",
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: "Dit bericht is van een 'Great Place To Work'-bedrijf",
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName} is een gecertificeerde Great Place To Work',
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. sed fingilla pretium nunv, niet vestibulum tellus imperdiet sed.',
                    readMore: 'Klik om meer te lezen',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Deadline voor aanmelding',
            location: 'Plaats',
            employmentType: 'Soort dienstverband',
            languageRequirements: 'Taalvereisten',
            workPermitRequirements: 'Vereisten voor werkvergunningen',
            preferredEducationField: 'Voorkeur opleidingsveld',
            preferredEducationLevel: 'Voorkeur opleidingsniveau',
            jobTags: 'Tags',
            apply: 'Nu toepassen',
            verificationRequired: 'Je moet je school-e-mailadres verifiëren om je aan te melden.',
            verificationRequiredHint:
                'je moet je school-e-mailadres verifiëren om je aan te melden',
            verificationPending: 'Je hebt een openstaande verificatie op deze school',
            verificationPendingHint: 'Je hebt een openstaande verificatie op deze school',
        },
        invalidJobAd: {
            caption:
                'Sorry, maar we konden deze positie niet vinden. Als je denkt dat dit een fout is, neem dan contact op met de ondersteuning via de onderstaande chatbox.',
            btn: 'Vind andere banen',
        },
    },
    mypage: {
        header: 'Mijn pagina',
        suggestedPositions: 'voorgestelde posities',
        favoriteModule: {
            header: 'Mijn favoriete posities',
            seeAll: 'Alles zien',
            noFavorites: 'Je hebt geen actieve favoriete posities',
        },
    },
    recoverpassword: {
        createPassword: 'Maak een nieuw wachtwoord',
        newPasswordLabel: 'Nieuw paswoord',
        newPasswordPlaceholder: 'Wachtwoord',
        confirmPasswordLabel: 'Bevestig wachtwoord',
        confirmPasswordPlaceholder: 'Bevestig wachtwoord',
        resetPasswordButton: 'Wachtwoord opnieuw instellen',
        resettingPassword: 'Wachtwoord resetten',
        passwordsNotMatching: 'Wachtwoorden komen niet overeen.',
    },
    recoveruser: {
        headerLabel: 'Herstel Highered-gebruiker',
        accountActivation: 'Account activatie',
        step1: {
            header: 'Welkom op ons nieuwe platform!',
            subHeader: 'kies hoe u verbinding wilt maken met uw account',
            description:
                'Voor een eenvoudiger inlogproces raden we u aan uw account te verbinden met ten minste een van de volgende services.',
            OR: 'of',
            emailAndPassword: 'Gebruik je eigen e-mailadres',
        },
        step2: {
            header: 'Gebruik e-mail en wachtwoord',
            description:
                'Dit is het belangrijkste e-mailadres dat aan uw account wordt gekoppeld. we raden je aan om een ​​ander e-mailadres te gebruiken dan je universiteitsadres om toegang te houden tot je gegevens na je afstuderen. U kunt eenvoudig bepalen welke e-mails u van ons ontvangt in uw accountinstellingen.',
            invalidEmail: 'Het opgegeven e-mailadres is geen geldig e-mailadres.',
            passwordsNotMatch: 'De wachtwoorden moeten overeenkomen',
            passwordDescription01:
                'om uw accountbeveiliging te garanderen, moet u een nieuw wachtwoord instellen. Maak een wachtwoord aan met het volgende:',
            passwordDescription02: 'Minimaal 8 tekens',
            passwordDescription03: 'Ten minste één kleine letter (a-z)',
            passwordDescription04: 'Ten minste één hoofdletter (A-Z)',
            passwordDescription05: 'Ten minste één cijfer of speciaal symbool (0-9, !#$ enz.)',
            passwordDescription06: 'Minstens 6 unieke karakters',
            repeatPassword: 'herhaal wachtwoord',
        },
        step3: {
            header: 'Activerende gebruiker',
            loadingHints: {
                '0': 'Gebruikersgegevens laden',
                '1': 'Alles klaarmaken',
                '2': 'Nieuwe mogelijkheden om de hoek',
                '3': 'Bijna klaar!',
            },
            successHeader: 'Je account is nu klaar voor gebruik!',
            successSubheader: 'Je hebt nu toegang tot nieuwe exclusieve functies!',
            errorHeader: 'Kon account niet activeren',
            ifWrongContact:
                'Als je denkt dat dit niet klopt, neem dan contact op met de ondersteuning',
            contactForHelp: 'contact voor hulp',
            goBack: 'Ga terug',
        },
    },
    resourcesInternal: {
        header: 'Bronnen',
        resourceTypeHeader: 'Type',
        resourceNoContent: 'Je school heeft de bronfunctie nog niet geactiveerd.',
        resourceFolderNoContent: 'Er zijn geen beschikbare bronnen in deze map',
        resourceTitleHeader: 'Titel',
        resourcePublishDateHeader: 'gepubliceerd',
        searchPlaceholder: 'Zoek op naam of trefwoord...',
        cvTemplateHeader: 'VERHOOGD CV-TEMPLATE (ATS-VRIENDELIJK)',
        cvTemplateSubtitle: 'Download hier!',
    },
    shared: {
        userNavSection: {
            myPage: 'Mijn pagina',
            myProfile: 'Mijn profiel',
            myTests: 'Beoordelingen',
            myApplications: 'Toepassingen',
            myFavorites: 'Favorieten',
            internalResources: 'bronnen',
            calendar: 'Kalender',
            documents: 'CV uploaden',
        },
        searchModule: {
            searchBar: { label: 'Zoeken op titel of trefwoorden' },
            filters: { clearFilters: 'Wis filters' },
            filterLimit: {
                title: 'Filterlimiet bereikt',
                message: 'Er kunnen geen filters van dit type meer worden geselecteerd',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Posities',
                estimatedCount: 'ca {count} van {totalCount}',
                knownCount: '{count} van {totalCount}',
                noMatchFound: 'Kon niets vinden dat aan uw criteria voldoet',
            },
            postItem: { applyBefore: 'Deadline voor aanmelding' },
            postCard: { deadline: 'Deadline' },
        },
        loginModule: {
            emailVerificationTip: 'het kan een paar minuten duren voordat het uw inbox bereikt.',
            noEmail: 'Geen e-mail? Controleer uw spamfilter of:',
            logIn: 'Log in',
            socialAuthBtns: {
                continueWithFacebook: 'Ga verder met Facebook',
                continueWithGoogle: 'Ga verder met Google',
                continueWithLinkedIn: 'Ga verder met LinkedIn',
                continueWithWeChat: 'Ga verder met WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Gelieve uw e-mail te verifiëren',
                weSentAnEmailTo: 'We hebben een verificatie gestuurd naar:',
                continueToSignIn: 'Doorgaan met inloggen',
                resendEmail: 'Verificatielink opnieuw verzenden',
                newEmailSent: 'nieuwe e-mail verzonden',
            },
            registerForm: {
                recommendation:
                    'We raden je aan om je persoonlijke e-mailadres te gebruiken en niet je school-e-mailadres om ervoor te zorgen dat je toegang hebt tot je gegevens nadat je bent afgestudeerd.',
                register: 'Register',
                passwordsNotMatch: 'de wachtwoorden komen niet overeen',
            },
            logInPaper: {
                useEmail: 'of gebruik je e-mail',
                noAccount: 'Heb je geen account?',
                signUp: 'Inschrijven',
                logInToAccess: 'Log in om toegang te krijgen tot deze functie',
                showAllOptions: 'toon alle login-opties',
                hideAllOptions: 'Laat minder zien',
            },
            logInForm: { logIn: 'Log in', forgotPassword: 'Wachtwoord vergeten?' },
            forgotPassword: {
                title: 'Wachtwoord reset aanvragen',
                description:
                    'Geen zorgen - iedereen vergeet wel eens zijn wachtwoord.\n Voer hieronder je e-mailadres in om je wachtwoord opnieuw in te stellen',
                resetPassword: 'Wachtwoord opnieuw instellen',
                emailSentTitle: 'Uw hulp is onderweg!',
                emailHasBeenSent:
                    'er is een e-mail verzonden naar\n <br>\n <strong>{email}</strong>\n <br>\n met instructies voor het opnieuw instellen van uw wachtwoord. Controleer uw\n inbox.',
                noEmail: 'Geen e-mail?',
                sendEmailOneMoreTime: 'stuur nog een keer een e-mail',
                resendErrorTitle: 'Fout tijdens het herstellen van wachtwoord',
                resendErrorMessage:
                    'Kon geen e-mail met herstelwachtwoord verzenden. Misschien verkeerde e-mail?',
            },
        },
        universityBadges: {
            addAnotherUniversity: 'Nog een universiteit toevoegen',
            verificationDialog: {
                verifiedStudent: 'Geverifieerde {schoolAbbr} leerling',
                verificationDescription:
                    'Je bent een geverifieerde {schoolAbbr}-student met het e-mailadres {email}',
                verificationDescriptionNoEmail: 'Je bent een geverifieerde {schoolAbbr} student',
                checkYourEmail: 'controleer je {schoolAbbr} e-mail.',
                sentEmailDescription:
                    'We hebben je een e-mail gestuurd over verificatie voor {schoolAbbr} op {email}. Controleer uw e-mail.',
                resendEmail: 'Email opnieuw verzenden',
                cancelVerification: 'Verificatie annuleren',
                notYetVerified: 'Universiteitslidmaatschap nog niet geverifieerd.',
                verifyYourAffiliation:
                    'om toegang te krijgen tot specifieke functies van {schoolAbbr}, zoals exclusieve vacatures en bronnen, moet u uw aansluiting verifiëren.',
                verify: 'Verifiëren',
                goToPlatform: 'Ga naar platform',
                verificationPending: 'Verificatie in behandeling',
                verificationPendingDescription:
                    'De loopbaanservices van {schoolAbbr} verifiëren je verzoek. U wordt per e-mail gecontacteerd wanneer de verificatie is voltooid.',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: 'geverifieerde {uniSubDomain} student',
                    verifiedStudentWithEmail:
                        'Je bent een geverifieerde {uniSubDomain}-student met het e-mailadres {email}',
                    checkEmail: 'Controleer uw {uniSubDomain} e-mail.',
                    sentEmailInfo:
                        'We hebben u een e-mail gestuurd met betrekking tot verificatie voor {uniSubDomain} op {email}. Controleer uw e-mail.',
                    resendEmail: 'Email opnieuw verzenden',
                    cancelVerification: 'Verificatie annuleren',
                    notYetVerified: 'universitaire aansluiting nog niet geverifieerd.',
                    resourceAccessInfo:
                        'Om toegang te krijgen tot specifieke functies van {uniSubDomain}, zoals exclusieve vacatures en bronnen, moet u uw aansluiting verifiëren.',
                    verificationCancelled: 'Verificatie geannuleerd',
                    emailSent: 'Email verzonden',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: 'algemene voorwaarden',
            privacyPolicy: 'Privacybeleid',
            talentPanel: 'School/werkgever?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'verwijderd',
                deletedTitle: 'Deze functie is niet langer beschikbaar',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'het lijkt erop dat de pagina die u zocht er niet meer is.',
            goToHome: 'Ga naar homepagina',
            contactus: 'Neem contact met ons op',
        },
        chat: {
            liveNow: 'Live op chat nu!',
            seeAll: 'Alle',
            schoolSpecificChats: 'Snelle toegang',
            help: 'Hulp nodig?',
            chatExistsLabel: 'Chat bestaat',
        },
        countdown: {
            day: 'dag',
            days: 'dagen',
            hour: 'uur',
            hours: 'uur',
            minute: 'minuut',
            minutes: 'minuten',
            second: 'tweede',
            seconds: 'seconden',
        },
    },
    spotlight: {
        header: 'Mijn profiel',
        saveChangesToSubmit: 'Sla je profiel op om de wijzigingen door te voeren',
        saveChanges: 'Wijzigingen opslaan',
        saveSuccessful: 'uw wijzigingen zijn succesvol opgeslagen',
        personalDetails: {
            header: 'Persoonlijke gegevens',
            firstName: 'Voornaam',
            lastName: 'Achternaam',
            nationality: 'Nationaliteit',
            gender: 'Geslacht',
            uploadProfileImage: 'Upload foto',
            genderOptions: {
                male: 'Mannelijk',
                female: 'Vrouwelijk',
                other: 'Ander',
                none: 'Zeg ik liever niet',
                unknown: 'Onbekend',
            },
            wrongFileTypeErrorHeader: 'Ongeldig bestandstype',
            wrongFileTypeErrorDescription: 'Je kunt alleen afbeeldingen uploaden',
        },
        summary: { header: 'Managementsamenvatting' },
        contactDetails: {
            header: 'Contact details',
            contactEmail: 'Contact email',
            phoneNumberHeader: 'Mobiele telefoonnummer',
            countryCode: 'Landcode',
            phoneNumber: 'Telefoonnummer',
            invalidEmail: 'getypte e-mail is geen geldige e-mail.',
            permanentEmail:
                'OPMERKING: Deze wijziging is permanent. Je kunt je e-mailadres maar één keer instellen.',
        },
        languages: {
            header: 'Talen',
            languageLabel: 'Taal',
            levelLabel: 'Niveau',
            addLanguage: 'Nieuwe taal toevoegen',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Elementaire vaardigheid',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Beperkte werkvaardigheid',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Professionele werkvaardigheid',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Volledige professionele vaardigheid',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Inheemse of tweetalige vaardigheid',
            },
        },
        education: {
            header: 'Onderwijs',
            addEducation: 'onderwijs toevoegen',
            notGraduated: 'Nog niet afgestudeerd',
            graduatedIn: 'Afgestudeerd in {datum}',
            dialog: {
                addNewEducation: 'Nieuwe opleiding toevoegen',
                degreeTitle: 'Programma',
                institution: 'Instelling',
                degreeType: 'Rang',
                fieldOfStudy: 'Studierichting',
                cannotFindField: 'Ik kan mijn veld niet vinden',
                studyStart: 'Begin maand',
                studyEnd: 'Afstudeermaand',
                invalidDegreeTitle: 'Je moet een titel van je programma invullen.',
                invalidSchool: 'Je moet een school selecteren.',
                invalidStartDate: 'Selecteer een startdatum.',
                invalidEndDate: 'Selecteer een afstudeerdatum.',
                invalidStudyPeriod: 'je kunt niet eerder afstuderen dan de startdatum.',
                invalidDegreeField: 'Vul a.u.b. een geldig studiegebied in.',
                invalidDegreeLevel: 'Selecteer een geldig niveau van je diploma.',
                selectStartDate: 'Begin datum',
                selectEndDate: 'Afstudeerdatum',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Bachelor opleiding',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Meester',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Land- en bosbouw',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Toegepaste Wetenschappen & Beroepen',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Kunst, design en architectuur',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Bedrijfsmanagement',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'informatica & IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economie',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Onderwijs en opleiding',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Techniek en technologie',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd': 'Milieustudies en aardwetenschappen',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Horeca, vrije tijd en sport',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Geesteswetenschappen',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Journalistiek en media',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Wet',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                        'Master of Science in innovatie en business',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Master in ontwikkelingsmanagement',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'master of Science in datawetenschap',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Geneeskunde & Gezondheid',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'MS in Financiën',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': 'MS in internationale bedrijfsstudies',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'MS in bedrijfsanalyse',
                    '7d832109-642a-4730-aada-26927eb683ee': 'MS in Management',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Natuurwetenschappen en wiskunde',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Sociale wetenschappen',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Ander',
                },
            },
        },
        workAuthorization: {
            header: 'Werkautorisatie',
            addWorkAuthorization: 'Werkautorisatie toevoegen',
            implicitValue: 'Op basis van uw nationaliteit',
            dialog: {
                selectCountry: 'Selecteer land',
                addEuWorkAuthorization: 'EU-werkvergunning toevoegen',
            },
        },
        communication: {
            header: 'Communicatie',
            sendMeUpdatesDescription:
                'Stuur mij per e-mail carrièrenieuws, vacatures en bedrijfsupdates',
        },
        errors: {
            imageUpload: {
                title: 'Kan afbeelding niet uploaden.',
                message: 'Afbeelding is te groot!',
            },
        },
        exitDialog: {
            title: 'Niet-opgeslagen wijzigingen gaan verloren',
            message:
                'U probeert de pagina te verlaten zonder uw wijzigingen op te slaan. Wil je je profiel opslaan voordat je verder gaat?',
            stayAction: 'blijf op deze pagina',
            saveAction: 'Profiel opslaan',
            continueAction: 'Doorgaan zonder op te slaan',
        },
    },
    tests: {
        header: 'Testen',
        unauthorized:
            'De tests bevinden zich momenteel in een gesloten bèta. U heeft nog geen toegang tot deze functies. Ze zullen binnenkort beschikbaar zijn!',
        error: 'Er is iets misgegaan bij het laden van de tests. Probeer het later opnieuw.',
        assessmentModule: { header: 'Uw beoordeling' },
        completedYourProfile:
            'je moet je profiel voltooien om toegang te krijgen tot deze beoordeling',
        toMyProfile: 'Mijn profiel bewerken',
    },
    vfair: {
        header: 'EFMD virtuele evenementen',
        activeNow: 'Voortgaande',
        visibilityPrivate: 'Privaat',
        visibilityNetwork: 'Netwerk',
        visibilityOpen: 'Open',
        interested: 'Register',
        attend: 'Woon het evenement bij',
        enterEvent: 'Ga naar het virtuele evenement',
        notinterested: 'Ik heb geen interesse meer',
        shownInterest: 'Geregistreerd',
        signUpToday: 'Schrijf je vandaag in!',
        vfairsInfo:
            'maak contact met bedrijven en organisaties van over de hele wereld, in een geavanceerde simulatieomgeving voor banenbeurzen die realtime interactie tussen recruiters en kandidaten mogelijk maakt. Klik op het virtuele evenement waarin je geïnteresseerd bent en meld je aan om meldingen te ontvangen.',
        recruitingOrgs: 'rekrutering Bedrijven & Organisaties',
        preRegistered: 'Vooraf geregistreerd',
        prepareForTheFair: 'Bereid je voor op het virtuele evenement',
        privateVFairHeader: 'Campus virtueel evenement',
        privateVFairMessage:
            'Dit virtuele evenement wordt gehost op een EFMD-schoolplatform en is daarom niet toegankelijk vanaf hier.',
        schoolNotJoinedNetworkEventMessage:
            'uw school heeft zich nog niet aangemeld voor dit virtuele evenement, neem contact op met uw programmadirecteur of loopbaanafdeling om deelname te vragen.',
        companyNotJoinedNetworkEventMessage:
            'Uw organisatie heeft geen actieve Virtual Booth op dit evenement. Neem contact op met Highered om deelname te vragen.',
        pavilions: 'Paviljoens',
        general: 'Algemeen',
        allCompanies: 'Alle bedrijven',
        lobby: 'Lobby',
        inviteCode: 'uitnodigingscode',
        eventRequiresInvitation: 'Voor dit evenement is een uitnodiging vereist',
        haveCode: 'ik heb een code',
        checkCode: 'Controleer code',
        invalidCode: 'Ongeldige code',
        registeredSuccessfully: 'Succesvol geregistreerd',
        pavilionTabs: {
            home: 'thuis',
            companies: 'bedrijven',
            articles: 'Lidwoord',
            jobs: 'banen',
            events: 'evenementen',
        },
        events: {
            noEventsAvailable: 'Geen evenementen beschikbaar',
            showCompleted: 'Toon voltooid',
            hideCompleted: 'Verbergen voltooid',
            liveNow: 'Leef nu',
            joinTheEvent: 'Doe mee met het evenement',
            addToCalendar: 'Toevoegen aan agenda',
        },
        links: {
            masterclasses: {
                header: 'Masterclasses',
                buttonCaption: 'Bekijk de Masterclasses',
                description:
                    'bekijk een breed scala aan masterclasses van topkwaliteit, waaronder "CV-optimalisatie om aangenomen te worden", "Rock Your Linkedin Profile" en "Salary Negotiation", onder vele anderen, voor alle fasen van je loopbaantraject',
            },
            detailsmasterclass: { header: 'Woon de masterclass bij' },
            cv: {
                header: 'CV-sjabloon',
                buttonCaption: 'CV-sjabloon downloaden',
                description:
                    'toegang tot het Highered ATS-vriendelijke CV-sjabloon om een ​​optimale professionele indruk te maken bij recruiters.',
            },
            elevatorPitch: {
                header: 'Elevator Pitch-uitdaging',
                buttonCaption: 'Stuur je pitch',
                description:
                    'Ga de "Pitch Perfect Challenge" aan! dit is je kans om je waarde te pitchen voor honderden recruiters van internationale topbedrijven en -organisaties',
            },
        },
        footerHeaders: {
            social: 'Volg ons voor meer updates',
            sponsored: 'Gesponsord door',
            organized: 'Georganiseerd door',
        },
        educationPopup: {
            step00: {
                header: 'Deel je opleiding',
                subtitle: 'Laat de werkgevers meer over u weten om door te gaan',
                continueLabel: 'Mijn opleiding toevoegen',
                leaveLabel: 'Afwijzen',
            },
            step01: { header: 'Vertel ons uw opleiding' },
            step02: { loadingLabel: 'een ogenblikje...' },
            step03: {
                header: 'Opleiding afgerond',
                subtitle: 'U kunt nu uw profiel delen en interessanter zijn onder de werkgevers',
                continueLabel: 'Ga verder met het verkennen van het virtuele evenement',
            },
            error: {
                header: 'oeps! Er is een fout opgetreden!',
                subtitle:
                    'We kunnen uw educatieve informatie niet opslaan. Probeer het later nog eens.',
            },
        },
    },
};
